module.exports = __webpack_public_path__ + "media/images/working-hours-icon-9f0ec17720c8fb5d41c36e38f77c11c7.png";